export { default } from './Rating';
export { default as ratingClasses } from './ratingClasses';
export * from './ratingClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Rating/index.js
// module id = 874
// module chunks = 22